function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8347 8.29759L12.1967 8.93075L7.31349 4.06569L7.9515 3.43253C9.13275 2.25567 10.9568 2.10988 12.2974 2.99484L14.2997 1L15.2763 1.97301L13.274 3.96785C14.1623 5.30347 14.016 7.12073 12.8347 8.29759Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.32777 10.3879L7.89453 11.8167L8.62701 12.5464L7.98901 13.1796C6.80776 14.3565 4.98371 14.5023 3.64311 13.6173L1.64083 15.6121L0.664185 14.6391L2.66647 12.6443C1.77821 11.3086 1.92454 9.49139 3.10579 8.31454L3.74379 7.68138L4.47628 8.41113L5.90951 6.98233C6.0893 6.80321 6.38083 6.80321 6.56061 6.98233C6.74039 7.16144 6.74039 7.45189 6.56061 7.631L5.12737 9.05981L7.24343 11.168L8.67667 9.7392C8.85645 9.56008 9.14798 9.56008 9.32777 9.7392C9.50755 9.91831 9.50755 10.2088 9.32777 10.3879Z"
});

var SvgIcoUnplug = function SvgIcoUnplug(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#ffffff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoUnplug, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-unplug.62f30cc8.svg";
export { ForwardRef as ReactComponent };